var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportCreatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.6666C12.25 10.6506 11.2761 9.78634 9.91667 9.46602M8.75 11.6666C8.75 10.378 7.183 9.33329 5.25 9.33329C3.317 9.33329 1.75 10.378 1.75 11.6666M8.75 7.58329C10.0387 7.58329 11.0833 6.53862 11.0833 5.24996C11.0833 3.96129 10.0387 2.91663 8.75 2.91663M5.25 7.58329C3.96134 7.58329 2.91667 6.53862 2.91667 5.24996C2.91667 3.96129 3.96134 2.91663 5.25 2.91663C6.53866 2.91663 7.58333 3.96129 7.58333 5.24996C7.58333 6.53862 6.53866 7.58329 5.25 7.58329Z",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCreatorIcon);
export default __webpack_public_path__ + "static/media/report-creator-icon.081ce9baeda5612dc643f06429a6a290.svg";
export { ForwardRef as ReactComponent };